export const unityOptions = [
  { value: 'und', label: 'UNIDAD' },
  { value: 'doc', label: 'DOCENA' },

  // Masa
  { value: 'g', label: 'GRAMOS' },
  { value: 'kg', label: 'KILOGRAMOS' },
  { value: 'ar', label: 'ARROBA' },
  { value: 'lb', label: 'LIBRAS' },
  { value: 'oz', label: 'ONZAS' },

  // Volumen
  { value: 'ml', label: 'MILILITROS' },
  { value: 'l', label: 'LITROS' },

  // Longitud
  { value: 'cm', label: 'CENTÍMETROS' },
  { value: 'm', label: 'METROS' },

  // Empaque
  { value: 'cj', label: 'CAJA' },
  { value: 'pq', label: 'PAQUETE' },
  { value: 'sc', label: 'SACO' },
  { value: 'blt', label: 'BULTO' },

  // Tiempo
  { value: 'min', label: 'MINUTO' },
  { value: 'hr', label: 'HORA' },
  { value: 'dia', label: 'DÍA' },
  { value: 'mes', label: 'MES' },
  { value: 'anio', label: 'AÑO' },
];
